import { render, staticRenderFns } from "./BusinessPilotPage.vue?vue&type=template&id=08c85d4f&"
import script from "./BusinessPilotPage.vue?vue&type=script&lang=js&"
export * from "./BusinessPilotPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports